import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import OrderView from "@/components/OrderView";

export default function Track() {
  const [sp] = useSearchParams();
  const [f, setF] = useState({ code: sp.get("code") || "", email: sp.get("email") || "" });
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const d = sp.get("discord");
    if (d === "linked") toast.success("Discord connected. Opening your private ticket...");
    if (d === "error") toast.error("Discord connect failed. Press Connect Discord and try again.");
    if (d === "denied") toast.error("Discord connect was cancelled.");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.get("/orders/track", { params: f });
      setOrder(data);
    } catch (err) { setOrder(null); toast.error(errMsg(err)); }
  };

  useEffect(() => {
    if (f.code && f.email) {
      api.get("/orders/track", { params: f }).then((r) => setOrder(r.data)).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!order || (order.status !== "pending" && !(order.discord_id && !order.discord_channel_id))) return undefined;
    const interval = window.setInterval(async () => {
      try {
        const { data } = await api.get("/orders/track", { params: f });
        setOrder(data);
        if (data.status === "delivered") toast.success("Payment confirmed — your RSN transfer pack is ready");
      } catch {
        // Keep the existing ticket visible during a transient refresh failure.
      }
    }, 5000);
    return () => window.clearInterval(interval);
  }, [order, f]);


  return (
    <div className="max-w-3xl mx-auto px-5 pt-16" data-testid="track-page">
      <div className="overline-label mb-4">// order radar</div>
      <h1 className="font-display text-6xl md:text-8xl leading-[0.9] chrome-text mb-10">Track order</h1>
      <form onSubmit={submit} className="grid sm:grid-cols-[1fr_1fr_auto] gap-3 mb-10" data-testid="track-form">
        <input required className="field uppercase" placeholder="BR-XXXXXX" value={f.code} onChange={(e) => setF({ ...f, code: e.target.value })} data-testid="track-code-input" />
        <input required type="email" className="field" placeholder="Email used at checkout" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="track-email-input" />
        <button className="btn-bomb" data-testid="track-submit-button">Locate</button>
      </form>
      {order && <OrderView o={order} />}
    </div>
  );
}
